import * as React from "react";
import { withStyles, Typography, Button, Hidden } from "@material-ui/core";
import { observer } from "mobx-react";
import { SlideFade } from "../../../../content/components/effects/slide-fade";
import { ZoomFade } from "../../../../content/components/effects/zoom-fade";

var styles = function styles(theme) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j;

  return {
    root: (_a = {
      position: "relative"
    }, _a[theme.breakpoints.down("md")] = {
      height: "64vh"
    }, _a[theme.breakpoints.up("lg")] = {
      fontSize: "1.4em",
      padding: "5vw"
    }, _a[theme.breakpoints.up("md")] = {
      width: "100%",
      padding: "0 72px",
      display: "flex",
      flexDirection: "column"
    }, _a),
    bgVideo: (_b = {
      position: "fixed",
      top: 0,
      right: 0,
      bottom: 0,
      width: "170vw",
      left: "-35vw",
      height: "130vh"
    }, _b[theme.breakpoints.down("md")] = {
      top: "-50px",
      left: "-35vw",
      right: 0,
      width: "410vw",
      bottom: 0,
      height: "100vh"
    }, _b),
    backgroundShape: {
      position: "absolute",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      "&:after": {
        content: "' '",
        display: "block",
        position: "fixed",
        backgroundImage: 'url("https://d6j399hnl3eyg.cloudfront.net/thorax2022/cover_visual-fallback.jpg")',
        backgroundSize: "cover",
        backgroundPosition: "center",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        zIndex: -1
      }
    },
    logo: (_c = {
      position: "absolute",
      left: 84,
      top: 68,
      maxWidth: 370
    }, _c[theme.breakpoints.down("md")] = {
      maxWidth: 220,
      left: 40,
      top: 40,
      position: "fixed"
    }, _c),
    thoraxLogo: (_d = {
      width: 270,
      maxWidth: "100%"
    }, _d[theme.breakpoints.down("md")] = {
      marginBottom: 45
    }, _d),
    title: (_e = {
      position: "relative",
      marginBottom: theme.spacing(2),
      fontFamily: "CircularStd",
      fontSize: 120,
      color: "#fff"
    }, _e[theme.breakpoints.down("md")] = {
      fontSize: 40
    }, _e),
    buttonReadMore: (_f = {
      position: "absolute",
      right: -150,
      top: 310,
      color: "#3FC3BE",
      backgroundColor: "#fff",
      border: 0,
      borderRadius: 0,
      maxWidth: 185,
      marginBottom: theme.spacing(3),
      fontFamily: "CircularStd",
      fontWeight: 700,
      padding: "7px 36px",
      "&:hover": {
        backgroundColor: theme.palette.secondary.light
      }
    }, _f[theme.breakpoints.down("md")] = {
      right: 0
    }, _f),
    coverImage: (_g = {
      maxWidth: 800,
      height: "auto",
      marginLeft: 100
    }, _g[theme.breakpoints.down("md")] = {
      position: "relative",
      maxWidth: "80%",
      margin: "100px 10% 0 10%"
    }, _g),
    info: (_h = {
      position: "fixed",
      bottom: 100,
      right: 220
    }, _h[theme.breakpoints.down("md")] = {
      marginTop: 100,
      paddingBottom: "-180px",
      position: "relative",
      bottom: "unset",
      right: "unset"
    }, _h),
    content: (_j = {
      paddingLeft: theme.spacing(3),
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      paddingTop: 40
    }, _j[theme.breakpoints.down("md")] = {
      // marginTop: 150,
      marginLeft: 60,
      paddingBottom: 50,
      paddingRight: theme.spacing(3)
    }, _j)
  };
};

export var LayoutEditionCoverDesktop = withStyles(styles)(observer(function (_a) {
  var classes = _a.classes,
      config = _a.config,
      presenter = _a.presenter;
  var styles = config.styles || {};
  return React.createElement("div", {
    className: classes.root
  }, React.createElement("div", {
    className: classes.backgroundShape
  }, React.createElement(Hidden, {
    mdDown: true
  }, React.createElement("video", {
    className: classes.bgVideo,
    autoPlay: true,
    muted: true,
    loop: true
  }, React.createElement("source", {
    src: "https://d6j399hnl3eyg.cloudfront.net/thorax2022/cover-video.mp4"
  })))), React.createElement(ZoomFade, {
    timeout: 200
  }, React.createElement("img", {
    className: classes.logo,
    src: "https://d6j399hnl3eyg.cloudfront.net/thorax2022/logo-mst-wit.svg",
    alt: "MST"
  })), React.createElement("div", {
    className: classes.info
  }, React.createElement("div", {
    className: classes.content
  }, React.createElement(SlideFade, {
    direction: "up",
    timeout: 1000
  }, React.createElement("img", {
    className: classes.thoraxLogo,
    src: "https://d6j399hnl3eyg.cloudfront.net/thorax2022/logo-thorax.svg"
  })), React.createElement(SlideFade, {
    direction: "up",
    timeout: 1200
  }, React.createElement(Typography, {
    className: classes.title,
    variant: "h2",
    style: styles.title || {}
  }, React.createElement("span", {
    style: {
      color: "#3DBCBD"
    }
  }, "terugblik"), React.createElement("br", null), " op 2021")), React.createElement(SlideFade, {
    direction: "up",
    timeout: 1400
  }, React.createElement(Button, {
    onClick: function onClick() {
      window.location.href = "https://thorax-terugblik-2021.mst.nl/1976ba71-58d2-45a5-a325-c204d8bfbe69";
    },
    variant: "contained",
    className: classes.buttonReadMore
  }, "Inhoudsopgave")))));
}));